import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { stripBasePath } from '../utils/basePath';

const PrerenderSignal = () => {
  const location = useLocation();

  useEffect(() => {
    // Signal that the app is fully rendered after React Helmet has updated meta tags
    // The timeout ensures all async updates have completed
    // Premium page needs extra time due to heavy Spline 3D assets
    const normalizedPath = stripBasePath(location.pathname);
    const delay = normalizedPath === '/premium' ? 2000 : 800;
    
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined' && window.document) {
        console.log('[Prerender] Dispatching app-rendered event for path:', normalizedPath);
        window.document.dispatchEvent(new Event('app-rendered'));
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [location.pathname]); // Re-fire on route changes

  return null;
};

export default PrerenderSignal;
